const pre = '/bcos/contract/';

export default {
    path: '/bcos/contract',
    title: '合约管理',
    header: '',
    icon: 'md-cloud-outline',
    children: [
        {
            path: `${pre}ide`,
            title: '合约 IDE',
        },
        {
            path: `${pre}list`,
            title: '合约列表',
        },
        {
            path: `${pre}warehouse`,
            title: '合约仓库',
        },
        {
            path: `${pre}cns`,
            title: 'CNS 查询',
        },
        {
            path: `${pre}crud`,
            title: 'CRUD',
        },
        {
            path: `${pre}eventCheck`,
            title: 'Event 查看',
        },
    ]
}
